/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './Renegociacao25Parceiros.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import { isMobile } from '@/utils/browser';

function Renegociacao25Parceiros() {
  return (
    <>
      <section id="renegociacao25-parceiros">
        <ContainerHome24>
          <div className="parceiros-textos">
            <h2 className="parceiros-titulo">Conheça nossos parceiros</h2>
            <p className="parceiros-texto">
              Com eles você também pode negociar suas dívidas de maneira fácil e segura.
            </p>
          </div>
          <div className="parceiros-carrossel">
            <CustomEmblaCarouselHome24
              loop
              enableBullets
              detectBulletCount
              // hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
              options={{ slidesToScroll: isMobile() ? 2 : 4 }}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/em-dia.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/em-dia.png"
                      />
                      <img src="assets/renegociacao25/parceiros/em-dia.png" alt="Em dia" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/quiteja.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/quiteja.png"
                      />
                      <img src="assets/renegociacao25/parceiros/quiteja.png" alt="Quite já" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/serasa.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/serasa.png"
                      />
                      <img src="assets/renegociacao25/parceiros/serasa.png" alt="Serasa" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/negociedigital.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/negociedigital.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/negociedigital.png"
                        alt="Negocie Digital"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/paschoalotto.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/paschoalotto.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/paschoalotto.png"
                        alt="Paschoalotto"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/pagoufacil.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/pagoufacil.png"
                      />
                      <img src="assets/renegociacao25/parceiros/pagoufacil.png" alt="Pagou Fácil" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/goes.webp"
                      />
                      <source type="image/png" srcSet="assets/renegociacao25/parceiros/goes.png" />
                      <img
                        src="assets/renegociacao25/parceiros/goes.png"
                        alt="Goes e Nicoladelli Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/stocco.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/stocco.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/stocco.png"
                        alt="Stocco Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/pdtec.webp"
                      />
                      <source type="image/png" srcSet="assets/renegociacao25/parceiros/pdtec.png" />
                      <img src="assets/renegociacao25/parceiros/pdtec.png" alt="PD Tec" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/schulze.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/schulze.png"
                      />
                      <img src="assets/renegociacao25/parceiros/schulze.png" alt="Schulze" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/almaviva.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/almaviva.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/almaviva.png"
                        alt="Almaviva Exxperience"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/nunes-romero-advogados.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/nunes-romero-advogados.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/nunes-romero-advogados.png"
                        alt="Nunes Romero Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/crespo.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/crespo.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/crespo.png"
                        alt="Crespo e Caires Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source type="image/webp" srcSet="assets/renegociacao25/parceiros/ocl.webp" />
                      <source type="image/png" srcSet="assets/renegociacao25/parceiros/ocl.png" />
                      <img src="assets/renegociacao25/parceiros/ocl.png" alt="OCL Advogados" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/kawasaki-sociedade-de-advogados.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/kawasaki-sociedade-de-advogados.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/kawasaki-sociedade-de-advogados.png"
                        alt="Kawasaki Sociedade de Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/bellinati-perez.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/bellinati-perez.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/bellinati-perez.png"
                        alt="Bellinati Perez Seriedade, competência e Inovação"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/macbarbosa.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/macbarbosa.png"
                      />
                      <img src="assets/renegociacao25/parceiros/macbarbosa.png" alt="Mac Barbosa" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/hcosta.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/hcosta.png"
                      />
                      <img src="assets/renegociacao25/parceiros/hcosta.png" alt="Hcosta" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/melillo.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/melillo.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/melillo.png"
                        alt="Melillo Wilians Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/nelson.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/nelson.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/nelson.png"
                        alt="Nelson Advogados"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/antonio.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/antonio.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/antonio.png"
                        alt="Antônio Advocacia"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/winover.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/winover.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/winover.png"
                        alt="Winover Contact"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/sanchez.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/sanchez.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/sanchez.png"
                        alt="Advocacia Sanchez"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/millennium.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/millennium.png"
                      />
                      <img
                        src="assets/renegociacao25/parceiros/millennium.png"
                        alt="Millennium Cobranças Empresariais"
                      />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/renegociacao25/parceiros/negocie.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/renegociacao25/parceiros/negocie.png"
                      />
                      <img src="assets/renegociacao25/parceiros/negocie.png" alt="Negocie +" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source type="image/webp" srcSet="assets/renegociacao25/parceiros/neo.webp" />
                      <source type="image/png" srcSet="assets/renegociacao25/parceiros/neo.png" />
                      <img src="assets/renegociacao25/parceiros/neo.png" alt="Neohypeone" />
                    </picture>
                  </div>
                  <div className={`slide ${className}`}>
                    <picture>
                      <source type="image/webp" srcSet="assets/renegociacao25/parceiros/lab.webp" />
                      <source type="image/png" srcSet="assets/renegociacao25/parceiros/lab.png" />
                      <img src="assets/renegociacao25/parceiros/lab.png" alt="Lab Recuperações" />
                    </picture>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25Parceiros;
